// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-notice[data-v-98223678]{background-color:#dbe8f1;display:flex;flex-direction:row;font-family:\"Sofia Pro\",sans-serif;font-size:1.4rem;font-style:normal;font-weight:400;gap:.8rem;line-height:140%;padding:1.2rem 1.6rem;position:relative;text-align:left;z-index:-1}.feature-notice svg[data-v-98223678]{flex-shrink:0;height:1.6rem;margin-top:.4rem;width:1.6rem}.feature-notice .close-icon[data-v-98223678]{cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
